/*
 * @Description:全局状态管理
 * @Author: kai.zhou
 * @Date: 2020-03-25 14:39:19
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-07 14:42:47
 */
import { createStore, combineReducers } from "redux";

//定义初始化数据
const initData = {
  christmasInit:false,//音乐播放
  landMesCover:0,//用户信息弹窗0初始状态隐藏1展示2用户关闭
};
//定义dispatch调用的action
//音乐播放
export const setChristmasInit= (v: any) => {
  return { type: "setChristmasInit", data: v };
};
//用户信息弹窗
export const setLandMesCover= (v: any) => {
  return { type: "setLandMesCover", data: v };
};

//定义action触发state改变
const defaultState = (state: any = initData, action: any) => {
  switch (action.type) {
    case "setChristmasInit"://生日聚会音乐播放
      return { ...state, ...{ christmasInit: action.data } };
    case "setLandMesCover"://用户信息弹窗
      return { ...state, ...{ landMesCover: action.data } };
    default:
      return state;
  }
};

// 全局你可以创建多个reducer 在这里统一在一起
const defaultStore = combineReducers({ defaultState });
// 全局就管理一个store
export const store = createStore(defaultStore);
